import { render, staticRenderFns } from "./User.vue?vue&type=template&id=6087676a&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"
import style0 from "./User.vue?vue&type=style&index=0&lang=less&"
import style1 from "./User.vue?vue&type=style&index=1&id=6087676a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087676a",
  null
  
)

export default component.exports